export function authHeader() {
  // return authorization header with jwt token
  let user = JSON.parse(localStorage.getItem('user'));

  if (user && user.token) {
    return { 'Authorization': 'Bearer ' + user.token, 'Content-Type': 'application/json' };
  } else {
    return {};
  }
}

export function profilePhotoAuthHeader() {
  // return authorization header with jwt token
  let user = JSON.parse(localStorage.getItem('user'));

  if (user && user.token) {
    return { 'Authorization': 'Bearer ' + user.token };
  } else {
    return {};
  }
}


// Handle HTTP errors since fetch won't.
export function handleErrors(response) {
  if (!response.ok) {
    throw Error(response.statusText);
  }
  return response;
}

export function buildSortString(sorter) {
  let sortString = '';
  if (sorter !== undefined && sorter.field !== undefined) {
    let order = sorter.order === 'ascend' ? 'asc' : 'desc';
    sortString = `&q[s]=${sorter.field}+${order}`
  }
  return sortString;
}

export function buildFilterString(filters) {
  let result = '&';
  if (filters !== undefined) {
    Object.keys(filters).forEach(function (key) {
      if (filters[key]) {
        if (key === 'tag_condition') {
          result += `&tags_filter[tag_condition_type]=${encodeURIComponent(filters[key])}`;
        }
        if (key === 'tag_list' && Array.isArray(filters[key])) {
          filters[key].forEach(function (tag) {
            result += `&tags_filter[tags][]=${encodeURIComponent(tag)}`;
          });
        }
        if (key === 'status' || key === 'state') {
          filters[key].forEach(function (element) {
            result += `&q[state_in][]=${element}`;
          });
        }
        if (key === 'product') {
          filters[key].forEach(function (element) {
            result += `&q[product_slug_in][]=${element}`;
          });
        }
        if (key === 'kind') {
          filters[key].forEach(function (element) {
            result += `&q[kind_eq]=${element}`;
          });
        }
        if (key === 'link_product') {
          filters[key].forEach(function (element) {
            result += `&q[link_product_slug_in][]=${element}`;
          });
        }
        if (key === 'created_at') {
          result += `&q[created_at_gteq]=${filters[key][0]}&q[created_at_lteq]=${filters[key][1]}`;
        }
        if (key === 'updated_at') {
          result += `&q[updated_at_gteq]=${filters[key][0]}&q[updated_at_lteq]=${filters[key][1]}`;
        }
      }
    });
  }
  return result;
}

export const buildQueryString = (query) => {
  if (!query) return "";

  const trimmedQuery = query.trim();
  const underscoreQuery = trimmedQuery.replace(/\s+/g, "_");

  const generalFields = [
    "order_number",
    "state",
    "contact_first_name",
    "contact_last_name",
    "contact_user_first_name",
    "contact_user_last_name"
  ];

  const generalQueryGroup = generalFields
    .map((field, index) => (
      `q[g][0][c][${index}][a][]=${field}&q[g][0][c][${index}][p]=cont&q[g][0][c][${index}][v][]=${trimmedQuery}`
    ))
    .join("&");

  const kindQueryGroup = `q[g][1][c][0][a][]=kind&q[g][1][c][0][p]=cont&q[g][1][c][0][v][]=${underscoreQuery}`;

  return `&q[g][0][m]=or&q[m]=or&${generalQueryGroup}&${kindQueryGroup}`;
};